function muiPropForwarding(...forwardedProps: string[]) {
  return (prop: string) =>
    forwardedProps.reduce(
      (prev, forwardedProp) => prev && prop !== forwardedProp,
      true
    );
}

export default muiPropForwarding;
